import { SearchFilters, SearchUseCase } from "@outschool/gql-backend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import _Random from "lodash/random";

import searchListingsQuery from "../../Search/graphql/searchListingsQuery";

type useParentsAlsoLikeListParams = {
  searchFilters: SearchFilters;
  limit?: number;
  pageLocation: string;
  searchUid: string;
};
export const useParentsAlsoLikeList = ({
  searchFilters,
  limit,
  pageLocation,
  searchUid,
}: useParentsAlsoLikeListParams) => {
  const { data } = useQueryWithPreviousData(searchListingsQuery, {
    variables: {
      searchFilters: {
        ...searchFilters,
        isAvailable: true,
      },
      skipRating: false,
      withRecentReviews: false,
      includeMatchingSections: true,
      limit: limit || null,
      useCase: SearchUseCase.RelatedContent,
      pageLocation,
      searchUid,
    },
    context: { doNotRetry: true },
  });

  return data?.searchListings?.listings;
};
